import React, { useEffect, useState } from "react";
import Post from "../../../../Apis/backlink/Post";
import { getAPIUrlBM } from "../../../../utils/config";
import Headers from "../../Common/Headers";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import SubscriberDropDown from "../../Common/SubscriberDropDown/SubscriberDropDown";
import { Helmet } from "react-helmet";
import favicon from "../../Assets/Favicon.png";
import Get from "../../../../Apis/backlink/Get";
import loadingGif from "../../Assets/loading.gif";
import RouteChecker from "../../../utils/RouteChecker";

function AddList() {
  const sweet = window.sweet;
  const [isloading, setIsloading] = useState(true);
  const navigate = useNavigate();
  const [lists, setLists] = useState();

  const header = {
    heading: "Add New List",
    link: "http://links.backlinkchecker.info/add-lists-tutorial",
    isSubHeading: false,
  };

  const [formData, setFormData] = useState({
    listName: "",
    subscribedUsers: "",
    frequency: "0",
    isPublic: true,
    isIndex: true,
    populateMoz: false,
  });

  const [errors, setErrors] = useState({
    listName: {
      valid: true,
      msg: "",
    },
    subscribedUsers: {
      valid: true,
      msg: "",
    },
    frequency: {
      valid: true,
      msg: "",
    },
  });

  const validation = () => {
    var valid = true;
    if (formData.listName.length !== 0) {
      var listName = formData.listName.trim();
      listName = listName.toLowerCase();
      if (
        lists?.find(
          (list) => list.list_name.trim().toLowerCase() === listName,
        ) !== undefined
      ) {
        setErrors({
          ...errors,
          listName: {
            msg: "List Name already exist!",
            valid: false,
          },
        });
        valid = false;
        return;
      } else if (listName.indexOf("#") !== -1) {
        setErrors({
          ...errors,
          listName: {
            msg: 'List Name cannot have "#"',
            valid: false,
          },
        });
        valid = false;
        return;
      }
    }
    if (formData.listName.length === 0) {
      setErrors({
        ...errors,
        listName: {
          msg: "List Name should not be Empty!",
          valid: false,
        },
      });
      // console.log(formData.listName.length);
      valid = false;
    } else if (formData.subscribedUsers.length === 0) {
      // console.log(formData.subscribedUsers);
      valid = false;
      setErrors({
        ...errors,
        subscribedUsers: {
          msg: "Please Select atleast one user.",
          valid: false,
        },
      });
    } else if (formData.frequency === "0") {
      // console.log(formData.frequency);
      valid = false;
      setErrors({
        ...errors,
        frequency: {
          msg: "Please select Frequency.",
          valid: false,
        },
      });
    }

    if (valid) {
      setErrors({
        listName: {
          valid: true,
          msg: "",
        },
        subscribedUsers: {
          valid: true,
          msg: "",
        },
        frequency: {
          valid: true,
          msg: "",
        },
      });
    }

    return valid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    var validInputs = true;
    switch (name) {
      case "listName":
        if (value.length > 25) {
          validInputs = false;
          setErrors({
            ...errors,
            listName: {
              msg: "List Name should be less than 25 characters!",
              valid: false,
            },
          });
        } else {
          setErrors({
            ...errors,
            listName: {
              msg: "",
              valid: true,
            },
          });
        }
        break;
      case "frequency":
        if (value === "0") {
          validInputs = false;
        } else {
          setErrors({
            ...errors,
            frequency: {
              msg: "",
              valid: true,
            },
          });
        }
        break;
      default:
        break;
    }
    if (validInputs) setFormData({ ...formData, [name]: value });
  };

  const InputBoxHeader = ({ title, description }) => {
    return (
      <div>
        <p className="title">{title}</p>
        <p className="description">{description}</p>
      </div>
    );
  };

  const handleSubmit = async () => {
    try {
      if (!validation()) return;
      const url = getAPIUrlBM();
      const connectedUser = formData.subscribedUsers;
      const response = await Post(url + "/createsubscriber", {
        emails: connectedUser,
      });
      if (response.message === "User Added Successfully") {
        // console.log(response);
        var userArr = [];
        response.response.forEach((id) => {
          userArr.push(id.primary_id);
        });
        const addList = await Post(url + "/createlist", {
          listName: formData.listName,
          frequency: formData.frequency,
          users: userArr,
          isPublic: formData.isPublic ? 1 : 0,
          // setting lastChecked empty so that it will be set up by cron
          lastChecked: "",
          notes: document.getElementById("notes").value,
          isIndex: formData.isIndex ? 1 : 0,
          populateMoz: formData.populateMoz ? 1 : 0,
        });
        if (addList.message === "List added sucessfully") {
          sweet({
            title: "Success!",
            text: "Congo!!! List Updated successfully",
            icon: "success",
          });
          navigate(`/backlink/link/add/${addList.listID}`);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSubsList = (subs) => {
    setFormData({ ...formData, subscribedUsers: subs });
    if (subs.length === 0 && formData.listName.length !== 0) {
      setErrors({
        ...errors,
        subscribedUsers: {
          msg: "Please select atleast one User!",
          valid: false,
        },
      });
    } else {
      setErrors({
        ...errors,
        subscribedUsers: {
          msg: "",
          valid: true,
        },
      });
    }
  };

  const getLists = async () => {
    try {
      const url = getAPIUrlBM();
      const res = await Get(url + "/getlistname");
      setLists(res.response);
      setIsloading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getLists();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <Helmet>
        <title>AddList - Backlink Checker</title>
        <meta
          name="description"
          content="Use backlink monitor to keep checking your backlinks & ensure they are not removed. After all, you paid for them with money, time or effort. Whenever you create a backlink, add it to Backlink Monitor to get notified if it is removed or edited and take necessary action proactively"
        />
        {/* <meta property="og:image" key="og:image" content={"/og_backLink.jpg"} /> */}
        {/* <meta property="og:url" content="https://app.linkly.digital/" /> */}
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />

        <meta property="og:title" content="AddList - Backlink Checker" />
        <meta
          property="og:description"
          content="Use backlink monitor to keep checking your backlinks & ensure they are not removed. After all, you paid for them with money, time or effort. Whenever you create a backlink, add it to Backlink Monitor to get notified if it is removed or edited and take necessary action proactively"
        />
      </Helmet>
      <RouteChecker url="listAddScreen">
        {!isloading ? (
          <>
            <Headers header={header} />

            <div className="inputSection">
              <div className="inputSubSection">
                <InputBoxHeader
                  title="List Name"
                  description="Name to recognize the list & display in the public dashboard"
                />
                <input
                  className="listInput"
                  name="listName"
                  type="text"
                  value={formData.listName}
                  onChange={handleChange}
                />
                {!errors.listName.valid && (
                  <p className="errorInput">{errors.listName.msg}</p>
                )}
              </div>
              <div className="inputSubSection">
                <InputBoxHeader
                  title="Subscribed Users"
                  description="Users to whom report has to be sent. User will have to verify their subscription."
                />
                <SubscriberDropDown
                  getSubsList={getSubsList}
                  curSelectedSubs={[]}
                  pageName="addListPage"
                />
                {!errors.subscribedUsers.valid && (
                  <p className="errorInput">{errors.subscribedUsers.msg}</p>
                )}
              </div>
              <div className="inputSubSection">
                <InputBoxHeader
                  title="Frequency"
                  description="Frequency to check the backlinks in this list"
                />
                <select
                  name="frequency"
                  value={formData.frequency}
                  className="frequencySelect"
                  onChange={handleChange}
                >
                  <option value="0">Select Frequency</option>
                  <option value="Once">Once</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Bi-Weekly">Biweekly</option>
                  <option value="Monthly">Monthly</option>
                </select>
                {!errors.frequency.valid && (
                  <p className="errorInput">{errors.frequency.msg}</p>
                )}
              </div>
              <div className="checkboxLabel">
                <label htmlFor="isPublic">
                  Make Public &nbsp; &nbsp; &nbsp;
                </label>
                <input
                  type="checkbox"
                  name="isPublic"
                  value={formData.isPublic}
                  checked={formData.isPublic}
                  onChange={() =>
                    setFormData({ ...formData, isPublic: !formData.isPublic })
                  }
                />
              </div>

              <p className="subDescription">
                Public status can't be changed later.
              </p>
              <div className="checkboxLabel">
                <label htmlFor="isPublic">
                  Check Indexing Status &nbsp; &nbsp; &nbsp;
                </label>
                <input
                  type="checkbox"
                  name="isIndex"
                  value={formData.isIndex}
                  checked={formData.isIndex}
                  onChange={() =>
                    setFormData({ ...formData, isIndex: !formData.isIndex })
                  }
                />
              </div>
              <p className="subDescription">
                You will have to add your free Custom Search API key by Google
                to check the indexing status of your backlinks.{" "}
                <Link
                  to="/backlink/user-api-keys"
                  style={{
                    textDecoration: "none",
                  }}
                >
                  Add here
                </Link>
                . This feature will be available on Plan 3 & above only.
                Temporarily available in all plans as a trial.
              </p>

              <div className="checkboxLabel">
                <label htmlFor="isPublic">
                  Populate DA and Spam Score &nbsp; &nbsp; &nbsp;
                </label>
                <input
                  type="checkbox"
                  name="populateMoz"
                  value={formData.populateMoz}
                  checked={formData.populateMoz}
                  onChange={() =>
                    setFormData({
                      ...formData,
                      populateMoz: !formData.populateMoz,
                    })
                  }
                />
              </div>
              <p className="subDescription">
                You will have to add your Moz API key to check the domain
                authority and spam score of your backlink. Add it here -
                <Link
                  state={{
                    tab: 2,
                  }}
                  to={"/backlink/user-api-keys"}
                >
                  app.backlinkchecker.info/backlink/user-api-keys
                </Link>
              </p>

              <div
                style={{
                  maxWidth: "50rem",
                  // marginTop: "0.65rem",
                }}
              >
                <p className="subHeading pb-1">Add Notes</p>
                <textarea
                  className="csvTextArea"
                  placeholder="Enter the notes here"
                  onChange={(e) => {
                    console.log(e.target.value);
                  }}
                  id="notes"
                ></textarea>
              </div>

              <button className="submitButton" onClick={handleSubmit}>
                Create New List
              </button>
            </div>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "89vh",
              margin: "-15px -30px",
            }}
          >
            <img
              style={{
                width: "82vw",
                height: "94vh",
              }}
              alt=""
              src={loadingGif}
            />
          </div>
        )}
      </RouteChecker>
    </div>
  );
}

export default AddList;
